export const columns = function () {
  // 服务单号，机构名称，车牌号，服务起期，服务止期，参统人，被服务人，车损(服务额度），车损标准服务费，三者(服务额度），三者标准服务费，司机(服务额度），司机标准服务费，乘客(服务额度），乘客标准服务费，应交合计（元），净费合计（元）
  return [
	  {
	    prop: "insBillId",
	    label: "流水号",
	    minWidth: 200,
	  },
    {
      prop: "bh",
      label: "服务单号",
      minWidth: 200,
    },
    {
      prop: "orgName",
      label: "机构名称",
      minWidth: 200,
    },
    {
      prop: "carNo",
      label: "车牌号",
      minWidth: 100,
    },
    {
      prop: "beginTime",
      label: "服务起期",
      minWidth: 200,
    },
    {
      prop: "endTime",
      label: "服务止期",
      minWidth: 200,
    },
    {
      prop: "cperson",
      label: "参统人",
      minWidth: 100,
    },
    {
      prop: "bperson",
      label: "被服务人",
      minWidth: 100,
    },
	{
	  prop: "payTime",
	  label: "交费时间",
	  minWidth: 100,
	},
    {
      prop: "car_tcfee",
      label: "车损(服务额度）",
      minWidth: 100,
    },
    {
      prop: "car_bztcfee",
      label: "车损标准服务费",
      minWidth: 100,
    },
    {
      prop: "three_tcfee",
      label: "三者(服务额度）",
      minWidth: 100,
    },
    {
      prop: "three_bztcfee",
      label: "三者标准服务费",
      minWidth: 100,
    },
    {
      prop: "driver_tcfee",
      label: "司机(服务额度）",
      minWidth: 100,
    },
    {
      prop: "driver_bztcfee",
      label: "司机标准服务费",
      minWidth: 100,
    },
    {
      prop: "passenger_tcfee",
      label: "乘客(服务额度）",
      minWidth: 100,
    },
    {
      prop: "passenger_bztcfee",
      label: "乘客标准服务费",
      minWidth: 100,
    },
	{
	  prop: "medical_tcfee",
	  label: "医保外用药(服务额度）",
	  minWidth: 100,
	},
	{
	  prop: "medical_bztcfee",
	  label: "医保外用药标准服务费",
	  minWidth: 100,
	},
    {
      prop: "yjtcfee",
      label: "应交合计（元）",
      minWidth: 100,
    },
    {
      prop: "netFee",
      label: "净费合计（元）",
      minWidth: 100,
    },
  ];
};

export default {};
